import { ConnectedAccountsResponse, DisconnectAccountResponse } from 'settings/types/ConnectedAccount';
import { get, post } from '../../common/ApiClient';

export const getConnectedAccounts = async (): Promise<ConnectedAccountsResponse> => {
  try {
    const { data } = await get<ConnectedAccountsResponse>('/users/connected-accounts', true);
    return data;
  } catch (error) {
    console.error('Error in getConnectedAccounts:', error);
    throw error;
  }
};

export const disconnectAccount = async (accountId: number): Promise<DisconnectAccountResponse> => {
  try {
    const formData = new FormData();
    formData.append('account_id', accountId.toString());

    const { data } = await post<DisconnectAccountResponse>('/users/disconnect-connected-account', true, formData);
    return data;
  } catch (error) {
    console.error('Error in disconnectAccount:', error);
    throw error;
  }
};
